import logger from 'utils/logger.util';

const L = logger('locationReplace');

const locationReplace = url => {
  try {
    window.location.replace(url);
    return true;
  } catch (e) {
    L.warn('locationReplace()', e);
    return false;
  }
};

// noinspection JSUnusedGlobalSymbols
export default locationReplace;
